import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { login_action, forgetPassword_action, forgetUpdatePassword_action, forgetGetOtp_action, verifyOtp_action } from '../../actions/authAction/auth_action';
import Modal from 'react-bootstrap/Modal';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage, toastError, toastSuccess } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator, loginPasswordValidator, loginUsernameValidator, otpValidator, confirmPasswordValidator } from '../../utils/Validator'
// import Modal from "react-modal";
import { getCartList_action } from '../../actions/userAction/cart_action'
import { countDownDate_action } from '../../actions/staticAction/static_action';
import moment from 'moment';

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userName: '',
            password: '',
            isLoading: false,
            forgetPassUsername: '',
            verifyEmail: '',
            userID: '',
            emailVerified: false,
            otp: '',
            isOTPverified: false,
            newPassword: '',
            confirmPassowrd: '',
            is_showpass: false,

        }
        // this.handleObscure = this.handleObscure.bind(this)
        this.onUpdateForgetPassword = this.onUpdateForgetPassword.bind(this)
        this.handleForgetPassSubmit = this.handleForgetPassSubmit.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getOtp = this.getOtp.bind(this)
        this.onVerifyOTP = this.onVerifyOTP.bind(this)
        this.handleObscure = this.handleObscure.bind(this)
    }

    async componentDidMount() {
        const isTimeout = await this.getCountDownDate();
        if (isTimeout) {
            this.props.navigate('/')
        } else {
            if (this.props.location != null) {
                console.log('pathname : ', this.props.location.pathname);
                var url;
                if (this.props.location.pathname != null && this.props.location.pathname.includes('/login/')) {
                    url = this.props.location.pathname != null && this.props.location.pathname.split("/login/")
                } else if (this.props.location.pathname != null) {
                    url = this.props.location.pathname != null && this.props.location.pathname.split("/")
                }

                console.log('url : ', url);
                var loginContent = url[url.length - 1]
                console.log('loginContent : ', loginContent);
                var splitContent = loginContent != null && loginContent != "" && loginContent.split("--")
                console.log('splitContent : ', splitContent[0], splitContent[1]);

                // this.getLoginPass(splitContent[0], splitContent[1]).then(res => {
                //     res && this.setState({
                //         userName: splitContent[1],
                //         password: res
                //     }, () => {
                //         if (loginContent != "" && loginContent != "login") {
                //             this.handleSubmit(true);

                //         }
                //     })
                // })
            }
        }
    }

    getCountDownDate() {
        const { } = this.state
        // this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['loginDate']
                        const targetDate = moment.utc(LaunchDate);
                        // Current date in UTC
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        return totalSeconds >= 0;
                    }
                    this.setState({ isLoading: false })
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    handleSubmit() {
        // event.preventDefault();
        const { userName, password } = this.state
        // this.props.navigate("/dashboard");
        var errMsg2 = loginPasswordValidator(password)
        var errMsg = loginUsernameValidator(userName)
        console.log("testing-------------->", userName, password, errMsg2, errMsg)

        if (errMsg2 != '' || errMsg != '') {
            toastError(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : '')
        } else {
            if (userName != ' ' && password != ' ') {
                this.setState({ isLoading: true })
                this.props
                    .login_action(userName.toString().trim(), password.toString().trim())
                    .then((data) => {
                        if (data.error != 1) {
                            sessionStorage.clear()
                            sessionStorage.setItem("userNameSS", userName)
                            sessionStorage.setItem("tokenSS", "token")
                            sessionStorage.setItem("MemberIDSS", data.data['MemberID'])
                            sessionStorage.setItem("loginDataSS", JSON.stringify(data.data))
                            sessionStorage.setItem("ContactPersonNameSS", data.data['ContactPersonName'])
                            sessionStorage.setItem("loginAccesslist", JSON.stringify(data.data['loginAccesslist']))
                            sessionStorage.setItem("CompanyNameSS", data.data['CompanyName'])
                            sessionStorage.setItem("RoleIDSS", data.data['RoleID'])
                            sessionStorage.setItem("UserIDSS", data.data['UserID'])
                            sessionStorage.setItem("MembershipNo", data.data['MembershipNo'])
                            sessionStorage.setItem("accessToken", data.data['accessToken'])
                            sessionStorage.setItem("refreshToken", data.data['refreshToken'])
                            if (data.data['RoleID'] == 5) {
                                this.props
                                    .getCartList_action(data.data['UserID'], data.data['MemberID'])
                                    .then((item) => {
                                        sessionStorage.setItem("cartItems", item.data[0].length)
                                    })
                                this.props.navigate("/memberDashboard", {
                                    state: {
                                        MemberID: data.data['MemberID'], Mode: 'view'
                                    }
                                });
                            } else if (data.data['RoleID'] == 1 || data.data['RoleID'] == 2 || data.data['RoleID'] == 3) {
                                this.props.navigate("/user_list");
                            }
                            // if (password.includes('CSR')) {
                            //     this.props.navigate("/changePassword", { state: { is_forgotPassword: true } });
                            // }
                            // else {
                            //     this.props.navigate("/selectExhibition");
                            // }

                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            console.log(data.msg)
                            toastError(data.msg)
                            sessionStorage.clear()
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
            else {
                this.setState({ isLoading: false })

                toastError('Please check user name and password')
            }
        }
    }

    handleForgetPassSubmit() {
        const { userName, password, forgetPassUsername } = this.state
        var errMsg = loginUsernameValidator(forgetPassUsername)

        if (errMsg != '') {
            toastError(errMsg != '' ? errMsg : '')
        } else {
            if (forgetPassUsername != ' ') {
                this.setState({ isLoading: true })
                this.props
                    .forgetPassword_action(forgetPassUsername.toString().trim())
                    .then((data) => {
                        if (data.error != 1) {
                            console.log(data.data[0].Email)
                            this.setState({ verifyEmail: data.data[0].Email, userID: data.data[0].UserID }, () => {
                                this.getOtp(data.data[0].Email)
                            })
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    }).catch(err => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    getOtp(email) {
        const { verifyEmail } = this.state
        var errMsg = emailValidator(email)
        if (errMsg) {
            toastError(errMsg)
        } else {

            this.props
                .forgetGetOtp_action(email)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, emailVerified: true })
                    }
                    else {
                        this.setState({ isLoading: false, email: '', emailVerified: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }
    onVerifyOTP() {
        const { otp } = this.state
        var errMsg = otpValidator(otp)
        setTimeout(() => {
            if (errMsg != '') {
                toastError(errMsg != '' ? errMsg : '')
            } else {
                if (otp != '') {
                    this.props
                        .verifyOtp_action(otp)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isOTPverified: true })
                                toastSuccess("OTP Verified Successfully")
                            }
                            else {
                                toastError("Invalid OTP")
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });
                }
            }
        }, 500);
    }

    onUpdateForgetPassword(e) {
        e.preventDefault();
        const { newPassword, confirmPassowrd, userID } = this.state
        this.setState({ isLoading: true })
        // this.props.navigate("/dashboard");
        var errMsg = loginPasswordValidator(newPassword)
        var errMsg2 = confirmPasswordValidator(newPassword.toString().trim(), confirmPassowrd.toString().trim())
        console.log(errMsg);
        console.log(errMsg2);
        if (errMsg != '' || errMsg2 != '') {
            toastError(errMsg != '' ? errMsg : errMsg2 != '' ? errMsg2 : '')
            this.setState({ isLoading: false })
        } else {
            if (newPassword != '' && confirmPassowrd != '') {
                this.props
                    .forgetUpdatePassword_action(userID, confirmPassowrd)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false, isOpen: false })
                            toast.success('Password Updated SuccessFully!', {
                                theme: 'colored',
                                autoClose: 1000,
                                hideProgressBar: true,
                            })
                            this.setState({ isOpen: false, emailVerified: false, otp: '', verifyEmail: '', forgetPassUsername: '', isOTPverified: false, newPassword: '', confirmPassowrd: '' }, () => {
                                sessionStorage.removeItem('NODE_OTP')
                            })
                        }
                        else {
                            this.setState({ isLoading: false, isOpen: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        }

    }

    handleObscure() {
        const { is_showpass } = this.state
        this.setState({ is_showpass: !is_showpass })
    }
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default form submission behavior if it's wrapped in a form
            this.handleSubmit(); // Call submit on Enter key press
        }
    };


    render() {
        const { userName, password, emailVerified, verifyEmail, isOTPverified, isLoading, isOpen, is_showpass, is_forgotPassword, is_verifyEmail, getOtp, forgetNewPass, forgetConfirmPass, is_loginForgotPassword } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <section class="Login_page" style={{ padding: 0 }} >
                    <div>
                        <img src="assets/img/login_img.jpg" style={{ width: "100%" }} />
                        <div class="container" >
                            <marquee
                                style={{ fontSize: "16px", color: "#fff", fontWeight: "500" }}
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                onMouseOver={(e) => e.target.stop()}
                                onMouseOut={(e) => e.target.start()}
                            >
                               <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                            </marquee>
                            <div class="row" data-aos="fade-up" data-aos-delay="500">
                                <div class="col-md-12 col-sm-12">
                                    <div class="login_main_div">
                                        <div class="login-wrap">
                                            <img src="assets/img/logo_2.png" class="logo_img_css" />
                                            <h2>Login</h2>
                                            <div class="form">
                                                <input type="text" value={userName} placeholder="Username" onChange={(e) => this.setState({ userName: e.target.value })} />

                                                <input type={is_showpass ? "text" : "password"}
                                                    placeholder="Password"
                                                    style={{ padding: "15px 30px 15px 15px" }}
                                                    value={this.state.password}
                                                    onKeyDown={this.handleKeyDown}
                                                    onChange={(e) => this.setState({ password: e.target.value })} required />
                                                <i
                                                    className={!is_showpass ? "fa fa-eye-slash login-view-eye" : "fa fa-eye login-view-eye"}
                                                    onClick={this.handleObscure}
                                                />
                                                <button onClick={() => this.handleSubmit()} class="btn btn-primary login_btn"> Sign in </button>
                                                <a class="" style={{ cursor: 'pointer' }} onClick={() => this.setState({ isOpen: true })}>Forgot Password</a>
                                            </div>


                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={isOpen} onHide={() => this.setState({ isOpen: false })}>
                    {!emailVerified ? <div class="modal-dialog custome_modal_dialog" style={{ marginTop: '50%' }}>
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="forgot_password_content">
                                    <img src="assets/img/forgotPassword_img.png" />
                                    <h4>Forgot Password</h4>
                                    <p>Enter your username and we'll send you a link to reset your password</p>
                                    <input type="text" class="form-control" placeholder="Enter Username" value={this.state.forgetPassUsername} onChange={((e) => this.setState({ forgetPassUsername: e.target.value }))} />
                                    <a class="submit_btn" onClick={() => this.handleForgetPassSubmit()}> Next </a>
                                    <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ isOpen: false, forgetPassUsername: '' })} class="forgot_pass_css" data-bs-dismiss="modal"><i class="fa fa-arrow-left"></i> Back to Login</a>
                                </div>

                            </div>


                        </div>
                    </div> : !isOTPverified ? <div class="modal-dialog custome_modal_dialog" style={{ marginTop: '50%' }}>
                        <div class="modal-content">
                            <div class="modal-body">
                                <div class="forgot_password_content">
                                    <img src="assets/img/forgotPassword_img.png" />
                                    <h4>Enter OTP</h4>
                                    <p >We have sent OTP on your registered email</p>

                                    <input type="text" class="form-control" placeholder="Enter OTP" value={this.state.otp} onChange={((e) => this.setState({ otp: e.target.value }))} />
                                    <a class="submit_btn" onClick={() => this.onVerifyOTP()}> Submit </a>
                                    <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ isOpen: false, emailVerified: false, otp: '', verifyEmail: '', forgetPassUsername: '' }, () => {
                                        sessionStorage.removeItem('NODE_OTP')
                                    })} class="forgot_pass_css" data-bs-dismiss="modal"><i class="fa fa-arrow-left"></i> Back to Login</a>
                                </div>

                            </div>


                        </div>
                    </div> :
                        <div class="modal-dialog custome_modal_dialog" style={{ marginTop: '50%' }}>
                            <div class="modal-content">
                                <div class="modal-body">
                                    <div class="forgot_password_content">
                                        <img src="assets/img/forgotPassword_img.png" />
                                        <h4>Password Reset</h4>

                                        <input type="password" style={{ padding: '7px 20px', marginBottom: '10px' }} placeholder="New Password" value={this.state.newPassword} onChange={((e) => this.setState({ newPassword: e.target.value }))} />
                                        <input type="password" style={{ padding: '7px 20px', marginBottom: '10px' }} placeholder="Confirm Password" value={this.state.confirmPassowrd} onChange={((e) => this.setState({ confirmPassowrd: e.target.value }))} />
                                        <a class="submit_btn" onClick={(e) => this.onUpdateForgetPassword(e)}> Submit </a>
                                        <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ isOpen: false, emailVerified: false, otp: '', verifyEmail: '', forgetPassUsername: '', isOTPverified: false, newPassword: '', confirmPassowrd: '' }, () => {
                                            sessionStorage.removeItem('NODE_OTP')
                                        })} class="forgot_pass_css" data-bs-dismiss="modal"><i class="fa fa-arrow-left"></i> Back to Login</a>
                                    </div>

                                </div>


                            </div>
                        </div>
                    }
                </Modal>
            </>)
    }
}

export default withRouter(connect(null, { login_action, forgetPassword_action, getCartList_action, forgetUpdatePassword_action, forgetGetOtp_action, countDownDate_action, verifyOtp_action })(Login));